import {FC} from 'react';
import capitalize from 'lodash/capitalize';

import {ColorLabel} from '@shared/components';
import {Color} from '@shared/types';
import {PaymentStatusFilter} from '../api';

import {
  COLOR__ERROR_LIGHT,
  COLOR__ERROR_SOFT_DARK,
  COLOR__SUCCESS,
  COLOR__SUCCESS_LIGHT,
  COLOR__WARNING_LIGHT,
  COLOR__WARNING_SOFT_DARK,
} from '@/theme/colors';

const status2BgColor: Record<string, Color> = {
  [PaymentStatusFilter.success]: COLOR__SUCCESS_LIGHT,
  [PaymentStatusFilter.failed]: COLOR__ERROR_LIGHT,
};

const status2TextColor: Record<string, Color> = {
  [PaymentStatusFilter.success]: COLOR__SUCCESS,
  [PaymentStatusFilter.failed]: COLOR__ERROR_SOFT_DARK,
};

interface Props {
  status: string;
}

export const PaymentStatusLabel: FC<Props> = ({status}) => {
  if (!status) {
    return null;
  }

  return (
    <ColorLabel
      display="inline-block"
      bgcolor={status2BgColor[status] ?? COLOR__WARNING_LIGHT}
      color={status2TextColor[status] ?? COLOR__WARNING_SOFT_DARK}
    >
      {capitalize(status)}
    </ColorLabel>
  );
};
